"use client";

import { useEffect, useState, type ReactNode } from "react";
import { SYSTEM_ERROR_EVENT } from "@/lib/system-errors";
import { SystemErrorScreen } from "./system-error-screen";

export function SystemErrorProvider({ children }: { children: ReactNode }) {
  const [hasSystemError, setHasSystemError] = useState(false);

  useEffect(() => {
    function handleSystemError() {
      setHasSystemError(true);
    }

    function handleRuntimeError() {
      handleSystemError();
    }

    function handleUnhandledRejection() {
      // The rejection remains visible to browser diagnostics; the provider only
      // takes over the unreliable UI and never renders the rejected value.
      handleSystemError();
    }

    window.addEventListener(SYSTEM_ERROR_EVENT, handleSystemError);
    window.addEventListener("error", handleRuntimeError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    return () => {
      window.removeEventListener(SYSTEM_ERROR_EVENT, handleSystemError);
      window.removeEventListener("error", handleRuntimeError);
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, []);

  if (hasSystemError) {
    return <SystemErrorScreen onRetry={() => window.location.reload()} />;
  }

  return children;
}
